import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({ title, subtitle, moreTo, moreLabel = '查看更多' }: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-6">
      <div className="flex items-center gap-3 min-w-0">
        <span className="w-1.5 h-6 md:h-7 rounded-full bg-primary-500"></span>
        <div className="min-w-0">
          <h2 className="font-heading font-bold text-lg md:text-2xl text-foreground-50 truncate">{title}</h2>
          {subtitle ? <p className="text-xs md:text-sm text-foreground-500 mt-0.5 truncate">{subtitle}</p> : null}
        </div>
      </div>
      {moreTo ? (
        <Link
          to={moreTo}
          className="shrink-0 inline-flex items-center gap-1 text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-lg"></i>
        </Link>
      ) : null}
    </div>
  );
}